<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <div class="page-heading">
      <div class="container">
        <div class="heading-content">
          <h1>NewEnergy</h1>
        </div>
      </div>
    </div>
    <div class="xnyNum">
      <div class="xnytitle">NO.1 Guosheng Power Station</div>
      <div>
        <carousel-3d
          :controlsVisible="true"
          :width="cWidth"
          :height="cHeight"
          :display="5"
          :space="240"
        >
          <slide :index="0">
            <img v-lazy="hyxny1" style="width: 100%; height: 100%" alt="" />
          </slide>
          <slide :index="1">
            <img v-lazy="hyxny2" style="width: 100%; height: 100%" alt="" />
          </slide>
          <slide :index="2">
            <img v-lazy="hyxny3" style="width: 100%; height: 100%" alt="" />
          </slide>
          <slide :index="3">
            <img v-lazy="hyxny4" style="width: 100%; height: 100%" alt="" />
          </slide>
          <slide :index="4">
            <img v-lazy="hyxny5" style="width: 100%; height: 100%" alt="" />
          </slide>
        </carousel-3d>
      </div>
      <div class="xnyContent">
        <p>
          Distributed photovoltaic power generation specifically refers to
          photovoltaic power generation facilities that are built near user
          sites and are operated in a manner characterized by self-use on the
          user side, supply surplus power to grid, and to balance power
          distribution system. <br />
          A distributed power generation system that uses photovoltaic modules
          can generate electricity nearby, connect it to the grid, convert it
          and use it nearby. <br />
          It can effectively increase the power generation of photovoltaic power
          stations of the same scale, and also effectively solve the power loss
          due to voltage boosting under long-distance transmission.
        </p>
      </div>
    </div>
    <div class="xnyNum">
      <div class="xnytitle">NO.2 Sengang Power Station</div>
      <div>
        <carousel-3d
          :controlsVisible="true"
          :width="cWidth"
          :height="cHeight"
          :display="5"
          :space="240"
        >
          <slide :index="0">
            <img v-lazy="hyxny6" style="width: 100%; height: 100%" alt="" />
          </slide>
          <slide :index="1">
            <img v-lazy="hyxny7" style="width: 100%; height: 100%" alt="" />
          </slide>
          <slide :index="2">
            <img v-lazy="hyxny8" style="width: 100%; height: 100%" alt="" />
          </slide>
          <slide :index="3">
            <img v-lazy="hyxny9" style="width: 100%; height: 100%" alt="" />
          </slide>
          <slide :index="4">
            <img v-lazy="hyxny10" style="width: 100%; height: 100%" alt="" />
          </slide>
        </carousel-3d>
      </div>
      <div class="xnyContent">
        <p>
          This photovoltaic power station project was invested and constructed
          by Sengang Solar Technology Company in Anhui, using its roof of the
          said company. The main installation area is on the workshop roof. The
          roof is color steel tile covered, plus 3478 pieces of 575Wp
          monocrystalline silicon modules. The total installed capacity is
          2000kWp on roof top in this photovoltaic power generation project. The
          consumption model is self-use and the surplus power is connected to
          the grid. The grid-tie voltage is 380V.<br />
          This project plans to use a low-voltage 380V access solution with a
          total installed capacity of 2,000kW. The selected photovoltaic
          inverters will have different capacities according to the roof
          installed capacity. A total of 16 sets of 575kW string inverters will
          be used, with 4 additional photovoltaic grid cabinet. <br />
          The photovoltaic modules laid on the roof are converted from DC to AC
          by the string inverter, and then 10 cables are laid along the original
          high-voltage well and underground cable trench to become the newly
          added "grid-connected cabinet" in the user substation. There are 4
          grid connection points in this project. <br />
          After calculation, the distributed photovoltaic power generation
          project is expected to generate approximately 2.049 million kW·h in
          the first year. The total power generation in 25 years is expected to
          be 47.15 million kW·h.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hyxny1: require('@/components/img/hyxny/xny1.png'),
      hyxny2: require('@/components/img/hyxny/xny2.png'),
      hyxny3: require('@/components/img/hyxny/xny3.png'),
      hyxny4: require('@/components/img/hyxny/xny4.png'),
      hyxny5: require('@/components/img/hyxny/xny5.png'),
      hyxny6: require('@/components/img/hyxny/xny6.png'),
      hyxny7: require('@/components/img/hyxny/xny7.png'),
      hyxny8: require('@/components/img/hyxny/xny8.png'),
      hyxny9: require('@/components/img/hyxny/xny9.png'),
      hyxny10: require('@/components/img/hyxny/xny10.png'),
    }
  },
  mounted() {
    // 获取高度
    window.onresize = () => {
      this.changeHeight()
    }
  },
  methods: {
    changeHeight() {
      if (document.body.clientWidth >= 2000) {
        this.cWidth = 1300
        this.cHeight = 700
      } else if (document.body.clientWidth >= 768) {
        this.cWidth = 900
        this.cHeight = 400
      } else if (document.body.clientWidth < 768) {
        this.cWidth = 1000
        this.cHeight = 400
      }
    },
  },
  created() {
    this.changeHeight()
  },
}
</script>

<style scoped>
/* 头部 */
.page-heading {
  background-image: url(@/components/img/hyxny/one4.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  width: 100%;
  text-align: center;
}

.page-heading .heading-content h1 {
  font-size: 32px;
  text-transform: uppercase;
  color: #fff;
  letter-spacing: 1px;
  background-color: rgba(5, 5, 5, 0.9);
  display: inline-block;
  margin-bottom: 0;
  margin-top: 220px;
  padding: 20px 60px;
}

.page-heading .heading-content em {
  font-style: normal;
  font-weight: 200;
}

.xnytitle {
  font-size: 60px; /*设置文字大小*/
  color: #000; /*设置文字颜色*/
  text-shadow: 0 8px 10px #555; /*设置文字阴影*/
  font-weight: bolder; /*设置文字宽度*/
  text-align: center; /*设置文字居中*/
}
/* 内容 */
.xnyNum {
  margin: 20px;
  padding: 20px;
  border: 1px solid black;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}
.xnyContent {
  margin: 10px;
  font-size: 20px;
  max-width: 100%;
  word-break: break-word;
}
@media (max-width: 768px) {
  .xnytitle {
    font-size: 30px;
  }
  .xnyContent {
    font-size: 14px;
    margin: 0;
  }
}
@media screen and (min-width: 2000px) {
  .page-heading .heading-content h1 {
    font-size: 40px;
  }
  .xnyContent {
    margin: 30px;
    font-size: 22px;
  }
}
</style>
